import { render, staticRenderFns } from "./ai_catalog_nav_tabs.vue.js?vue&type=template&id=12456c3e&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_nav_tabs.vue?vue&type=template&id=12456c3e&vue3"
import script from "./ai_catalog_nav_tabs.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_nav_tabs.vue?vue&type=script&lang=js&vue3"
export * from "./ai_catalog_nav_tabs.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_nav_tabs.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports